import asset_toggle from './asset-toggle.js';

var curCont = 0;
var trigger = false;
var content = [];
var clientGrid = document.querySelector('.client-grid');
var scrollDir = true;
var jump = true;
var scrollPos = 0;
var scrollContent = [];
var load_que = [];
var offscreen = [];


export default function clients_page(){

    clientGrid = document.querySelector('.client-grid');

    if(clientGrid){

        const maxScrollTop = clientGrid.scrollHeight - clientGrid.clientHeight;

        const randomScrollTop = Math.floor(Math.random() * maxScrollTop);
    
        clientGrid.scrollTo({
            top: randomScrollTop,
            left: 0,
            behavior: 'instant' 
        });

        scrollPos = randomScrollTop;


        window.autoScrollActive = true;
        const assetBoxs = document.querySelectorAll('.asset-toggle');


        function load_wave(length){

            for (let a = 0; a < length; a++) {
                const assetBox = assetBoxs[a];
                const firstAsset = assetBox.querySelector('.lazy');
                if(firstAsset){
                    firstAsset.src = firstAsset.dataset.src;
                    firstAsset.classList.remove('lazy');
                }
            }
        
        }

        function load_all_box(assetBox){

            const assets = assetBox.querySelectorAll('.lazy');
            for (let a = 0; a < assets.length; a++) {
                const asset = assets[a];
                if(a == 0){
                    asset.src = asset.dataset.src;
                    asset.classList.remove('lazy');
                }else{
                    load_que.push(asset);
                }
            }
            
        }

        function load_it(){

            
            if(load_que.length){
                let asset = load_que[0];

                const isElementVisible = checkVisibility(clientGrid, asset);

                if(isElementVisible){
                    asset.src = asset.dataset.src;
                    asset.classList.remove('lazy');
                    load_que.shift();
                }else{
                    observerIndi.observe(asset);
                    load_que.shift();
                }
            }

            window.requestAnimationFrame(load_it);

        }

        window.requestAnimationFrame(load_it);

        load_wave(assetBoxs.length);
        // load_wave(assetBoxs.length);


        const lazyLoadIndi = (entries, observer) => {
            
            entries.forEach(entry => {
              if (entry.isIntersecting) {

                const asset = entry.target;

                if(asset.classList.contains('lazy')){

                    asset.src = asset.dataset.src;
                    asset.classList.remove('lazy');
                    observer.unobserve(entry.target);
               
                }
                    
                observer.unobserve(entry.target);
              }

            });

        };
        
        const observerIndi = new IntersectionObserver(lazyLoadIndi, {
            rootMargin: '100px',
            threshold: 0.5
        });

    
        const lazyLoad = (entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                  load_all_box(entry.target);
                  observer.unobserve(entry.target);
              }
            });
        };
        
      
        const observer = new IntersectionObserver(lazyLoad, {
            rootMargin: '100px',
            threshold: 0.5
        });
        
      
        assetBoxs.forEach(assetBox => {
            observer.observe(assetBox);
        });
        

        curCont = 0;
        trigger = false;
        scrollDir = true;
        jump = true;

        scrollContent = clientGrid.querySelectorAll('.client-box');


        clientGrid.addEventListener('scroll', function(e){

            check_scroll();
    
        });
      

    }


}


function check_scroll(){

    var newPos = clientGrid.scrollTop;
        
    if(scrollPos < newPos){
        scrollDir = true;
    }else{
        scrollDir = false;
    }

    scrollPos = newPos;

    var conainerWidth = clientGrid.scrollHeight;
    var scrollLeft = (conainerWidth - window.innerHeight) - scrollPos;
    
    if(scrollLeft < 100 ){ 
        add_clone(clientGrid);
    }

    if(trigger && jump){



        let bound = trigger.getBoundingClientRect();
        let y = bound.y;


        if(scrollDir){

            if(y < 0){
                let fistBound = scrollContent[1].getBoundingClientRect();
                let scrollTo = fistBound.top + scrollPos; 

                if(window.innerWidth <= 659){
                    scrollTo = fistBound.top + scrollPos; 
                }
                
                jump = false;

                clientGrid.scrollTo({
                    top: scrollTo,
                    behavior: 'instant'
                });
                
            }

        }else{

            var first = scrollContent[0].getBoundingClientRect();
            var last  =  scrollContent[scrollContent.length-1].getBoundingClientRect();

            if(scrollPos < first.width){
                
                scrollTo = last.top  + scrollPos + window.innerHeight; 
                jump = false;

                clientGrid.scrollTo({
                    top: scrollTo,
                    behavior: 'instant'
                });
            
            }

        }

    }else{
        if(!window.touch){
            jump = true;
        }
    }


    var conainerWidth = clientGrid.scrollHeight;
    var scrollLeft = (conainerWidth - window.innerHeight) - scrollPos;
    
    if(scrollLeft < 100 ){ 
        check_scroll();
    }

    
};

function add_clone(scrollContent){

    var toClone = scrollContent.querySelectorAll('.client-box');
    let clone = toClone[curCont].cloneNode(true);

    clone.classList.remove('og');
    clone.classList.remove('bound-click');
    clone.classList.add('clone');
    
    
    if(!trigger && curCont == 1){
        if(!window.touch){
            trigger = clone;
        }
    }

    scrollContent.appendChild(clone);

    asset_toggle();

    curCont++;

    if(curCont >= toClone.length){
        curCont = 0;
    }

};


function checkVisibility(container, targetElement) {
    const containerRect = container.getBoundingClientRect();
    const targetRect = targetElement.getBoundingClientRect();
  
    const isVisible = (
      targetRect.top >= containerRect.top &&
      targetRect.left >= containerRect.left &&
      targetRect.bottom <= containerRect.bottom &&
      targetRect.right <= containerRect.right
    );
  
    return isVisible;
  }